import React from 'react'
import { Redirect } from 'react-router-dom'

const Index = () => <Redirect to="/settings/1/edit" />

export default Index
